// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../node_modules/postcss-loader/dist/cjs.js!../../components/library/style/breakpoint.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../node_modules/postcss-loader/dist/cjs.js!../../components/library/style/colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ArQqzvoCNIJoatk42g4g {
    background-color: #F8FAFF;

    width: 100%;
    min-height: calc(100vh - 75px);

    display: flex;
    justify-content: center;
}

.mwiF2K40nfy8MsMF_wJw {
    margin-top: 48px;

    background-color: white;
    border-radius: 5px;
    box-shadow: 0 0 15px ${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-gray-light"]};
    border: 1px solid ${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-gray-light"]};

    padding: 24px;
    width: 550px;
    height: max-content;
    box-sizing: border-box;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

._2n7fFUYy6WA39XFn7yCw {
    margin: auto;

    color: #5CCA54;
    font-size: 0;

    display: flex;
    justify-content: center;
    align-items: center;
}

._1XHhpWkbp_8DFxhgEy3X {
  font-size: 80px;
}

.U4rBKJqR2Q_WBD1AIx1b {
    font-family: Roboto, sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 21px;
    text-align: center;
}

.DGe9yEJHVneq_DM1POF_ {
    font-family: Roboto, sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 150%;
    text-align: center;
    letter-spacing: 0.005em;
    color: rgba(0, 0, 0, 0.55);
    margin-top: 0;
}

.p3W1zhrR1_ZjHR1T0yRV {
    width: 100%;
}

@media screen and (max-width: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["tablet"]}) {
    .mwiF2K40nfy8MsMF_wJw {
        min-width: unset;
        width: 90%;
    }

    .ArQqzvoCNIJoatk42g4g {
        padding-top: 75px;
    }

    ._2n7fFUYy6WA39XFn7yCw {
        width: 60px;
        height: 60px;
        margin-bottom: 16px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/views/ConfirmationSuccess/ConfirmationSuccess.module.css"],"names":[],"mappings":"AAOA;IACI,yBAAyB;;IAEzB,WAAW;IACX,8BAA8B;;IAE9B,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;;IAEhB,uBAAuB;IACvB,kBAAkB;IAClB,iEAAqC;IACrC,8DAAkC;;IAElC,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,sBAAsB;;IAEtB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,YAAY;;IAEZ,cAAc;IACd,YAAY;;IAEZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;IACI,+BAA+B;IAC/B,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,+BAA+B;IAC/B,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,uBAAuB;IACvB,0BAA0B;IAC1B,aAAa;AACjB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI;QACI,gBAAgB;QAChB,UAAU;IACd;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,mBAAmB;IACvB;AACJ","sourcesContent":["@value breakpoints: \"components/library/style/breakpoint.css\";\n@value desktop, laptop, tablet, mobile, mobile-xs from breakpoints;\n\n@value colors: \"components/library/style/colors.css\";\n@value color-gray-light from colors;\n\n\n.background {\n    background-color: #F8FAFF;\n\n    width: 100%;\n    min-height: calc(100vh - 75px);\n\n    display: flex;\n    justify-content: center;\n}\n\n.modal {\n    margin-top: 48px;\n\n    background-color: white;\n    border-radius: 5px;\n    box-shadow: 0 0 15px color-gray-light;\n    border: 1px solid color-gray-light;\n\n    padding: 24px;\n    width: 550px;\n    height: max-content;\n    box-sizing: border-box;\n\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n}\n\n.illustration {\n    margin: auto;\n\n    color: #5CCA54;\n    font-size: 0;\n\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.materialIcons {\n  font-size: 80px;\n}\n\n.title {\n    font-family: Roboto, sans-serif;\n    font-style: normal;\n    font-weight: 500;\n    font-size: 18px;\n    line-height: 21px;\n    text-align: center;\n}\n\n.description {\n    font-family: Roboto, sans-serif;\n    font-style: normal;\n    font-weight: normal;\n    font-size: 16px;\n    line-height: 150%;\n    text-align: center;\n    letter-spacing: 0.005em;\n    color: rgba(0, 0, 0, 0.55);\n    margin-top: 0;\n}\n\n.button {\n    width: 100%;\n}\n\n@media screen and (max-width: tablet) {\n    .modal {\n        min-width: unset;\n        width: 90%;\n    }\n\n    .background {\n        padding-top: 75px;\n    }\n\n    .illustration {\n        width: 60px;\n        height: 60px;\n        margin-bottom: 16px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"breakpoints": `"components/library/style/breakpoint.css"`,
	"desktop": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["desktop"]}`,
	"laptop": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["laptop"]}`,
	"tablet": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["tablet"]}`,
	"mobile": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["mobile"]}`,
	"mobile-xs": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["mobile-xs"]}`,
	"colors": `"components/library/style/colors.css"`,
	"color-gray-light": `${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-gray-light"]}`,
	"background": `ArQqzvoCNIJoatk42g4g`,
	"modal": `mwiF2K40nfy8MsMF_wJw`,
	"illustration": `_2n7fFUYy6WA39XFn7yCw`,
	"materialIcons": `_1XHhpWkbp_8DFxhgEy3X`,
	"title": `U4rBKJqR2Q_WBD1AIx1b`,
	"description": `DGe9yEJHVneq_DM1POF_`,
	"button": `p3W1zhrR1_ZjHR1T0yRV`
};
export default ___CSS_LOADER_EXPORT___;
